import React from 'react';
import { TableRow } from '@mui/material';
import { FormDateInput } from '~/components/FormComponents/FormDateInput.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { FinancialConditionTableCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableCell.tsx';
import { FinancialConditionTableDeleteCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableDeleteCell.tsx';
import type { IFinancialInvestmentRowProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/financialInvestments/types.ts';
import { FINANCIAL_CONDITION_FIELD_LABELS } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/constants.ts';
import {
  normalizeDecimalValue,
  normalizePercentageValue,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';
import { financialConditionTableFieldStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/styles.ts';

export const FinancialInvestmentRow: React.FC<IFinancialInvestmentRowProps> = ({
  index,
  canRemove,
  disabled,
  onRemove,
}) => (
  <TableRow>
    <FinancialConditionTableCell>
      <FormInput
        name={`financialInvestments.${index}.name`}
        label="Найменування підприємства / об’єкта інвестування"
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`financialInvestments.${index}.edrpou`}
        label="ЄДРПОУ"
        type="text"
        inputProps={{ inputMode: 'numeric' }}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`financialInvestments.${index}.sharePercent`}
        label={FINANCIAL_CONDITION_FIELD_LABELS.sharePercent}
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizePercentageValue}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`financialInvestments.${index}.amount`}
        label={FINANCIAL_CONDITION_FIELD_LABELS.amountThousands}
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizeDecimalValue}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormDateInput
        name={`financialInvestments.${index}.startDate`}
        label="Дата початку інвестування"
        disabled={disabled}
        sx={financialConditionTableFieldStyles.dateField}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableDeleteCell
      label={`Видалити фінансову інвестицію ${index + 1}`}
      disabled={disabled}
      hidden={!canRemove}
      onDelete={onRemove}
    />
  </TableRow>
);
